// Cookie-consent per categorie (Google Consent Mode v2). De keuze wordt in
// localStorage bewaard; het inline script in index.html laadt GTM al bij elk
// bezoek (Consent Mode default 'denied') en vertaalt de keuze naar Consent
// Mode-signalen via window.__applyConsent. Zie index.html voor de laad-logica.

export type ConsentCategories = {
  // Functioneel is altijd aan en heeft geen consent nodig; alleen deze twee
  // categorieën zijn optioneel.
  analytics: boolean;
  marketing: boolean;
};

const STORAGE_KEY = 'puntuit-cookie-consent';

declare global {
  interface Window {
    __applyConsent?: (c: ConsentCategories) => void;
    __loadFramed?: () => void;
    gtag?: (...args: unknown[]) => void;
  }
}

export function getConsentChoice(): ConsentCategories | null {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    if (!value) return null;
    // Terugval voor de oude binaire waarden (PR #10).
    if (value === 'accepted') return { analytics: true, marketing: true };
    if (value === 'rejected') return { analytics: false, marketing: false };
    const parsed = JSON.parse(value) as Partial<ConsentCategories>;
    if (parsed && typeof parsed === 'object') {
      return { analytics: Boolean(parsed.analytics), marketing: Boolean(parsed.marketing) };
    }
    return null;
  } catch {
    return null;
  }
}

export function saveConsentChoice(choice: ConsentCategories) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(choice));
  } catch {
    // localStorage kan geblokkeerd zijn (privémodus); de keuze geldt dan
    // alleen voor deze paginaweergave.
  }
  // GTM is door het inline script al geladen met Consent Mode op 'denied'.
  // Hier sturen we de update en laden we waar nodig Framed. Al geladen tags
  // krijgen bij afwijzen het 'denied'-signaal; Framed kan niet meer worden
  // ontladen, maar krijgt wel het signaal om te stoppen.
  window.__applyConsent?.(choice);
}

export const OPEN_COOKIE_BANNER_EVENT = 'puntuit:open-cookie-banner';

// Voor de footer-link "Cookie-instellingen": toont de banner opnieuw zodat
// een bezoeker de keuze kan aanpassen (AVG: intrekken moet net zo makkelijk
// zijn als geven).
export function openCookieBanner() {
  window.dispatchEvent(new Event(OPEN_COOKIE_BANNER_EVENT));
}
